/**
 * ŠABLÓNA "template_2" – PORTRAIT. Registruje sa v ../../dailyMenuTemplates.js.
 */
import React from "react";
import Template2Screen from "./Template2Screen";

export default function DailyMenuTemplate2Portrait() {
  return <Template2Screen orientation="portrait" />;
}
